import { Grid, TextField } from '@material-ui/core';
import React from 'react';
import FormSection from './atom/FormSection';

export default function AgentNoteSection({ cartitem, cartitemIndex, setAgentNote }) {
    return (
        <FormSection title="Notes and pickup location">
            <Grid item xs={12}>
                <TextField
                    variant="standard"
                    label="Agent note (optional)"
                    placeholder="This note is sent out to the customer in each email. Note changes in pickup location, some extra information, etc."
                    name="agentnote"
                    fullWidth
                    multiline
                    type="text"
                    defaultValue={cartitem?.agentnote?.agentnote}
                    onChange={ev =>
                        setAgentNote(cartitemIndex, {
                            ...cartitem?.agentnote,
                            agentnote: ev.target.value
                        })
                    }
                />
            </Grid>
            <Grid item xs={12} md={6} lg={8}>
                <TextField
                    label="Check In Location (optional)"
                    placeholder="This note is sent out to the customer in each email. Note changes in check in location, some extra information, etc."
                    name="checkinLocation"
                    fullWidth
                    type="text"
                    defaultValue={cartitem?.agentnote?.checkinLocation}
                    onChange={ev =>
                        setAgentNote(cartitemIndex, {
                            ...cartitem?.agentnote,
                            checkinLocation: ev.target.value
                        })
                    }
                />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <TextField
                    label="Check In Time (optional)"
                    placeholder="HH:mm"
                    name="checkinTime"
                    fullWidth
                    type="text"
                    defaultValue={cartitem?.agentnote?.checkinTime}
                    onChange={ev =>
                        setAgentNote(cartitemIndex, {
                            ...cartitem?.agentnote,
                            checkinTime: ev.target.value
                        })
                    }
                />
            </Grid>
            <Grid item xs={12} md={6} lg={8}>
                <TextField
                    label="Pick Up Location (optional)"
                    placeholder="This note is sent out to the customer in each email. Note changes in pickup location, some extra information, etc."
                    name="pickupLocation"
                    fullWidth
                    type="text"
                    defaultValue={cartitem?.agentnote?.pickupLocation}
                    onChange={ev =>
                        setAgentNote(cartitemIndex, {
                            ...cartitem?.agentnote,
                            pickupLocation: ev.target.value
                        })
                    }
                />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                <TextField
                    label="Pick Up Time (optional)"
                    placeholder="HH:mm"
                    name="pickupTime"
                    fullWidth
                    type="text"
                    defaultValue={cartitem?.agentnote?.pickupTime}
                    onChange={ev =>
                        setAgentNote(cartitemIndex, {
                            ...cartitem?.agentnote,
                            pickupTime: ev.target.value
                        })
                    }
                />
            </Grid>
        </FormSection>
    );
}
